.a0{width:100%;}